// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3GlwS","modalForm":"UpgradeEpcsModal_modalForm__2_M0a","modalFooter":"UpgradeEpcsModal_modalFooter__2i9ZY"};